// features/answers/answersSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ExerciseAnswer } from "../components/pages/learner/pages/exercise-page/exercise-page";

interface AnswersState {
  [key: string]: ExerciseAnswer;
}

const initialState: AnswersState = {};

const answersSlice = createSlice({
  name: "answers",
  initialState,
  reducers: {
    setAnswer(state, action: PayloadAction<ExerciseAnswer>) {
      const { entityKey } = action.payload;
      state[entityKey] = action.payload;
    },
    clearAnswers() {
      return {};
    },
    // Atomically replace the entire state — avoids intermediate empty state.
    replaceAnswers(_state, action: PayloadAction<AnswersState>) {
      return action.payload;
    },
  },
});

export const { setAnswer, clearAnswers, replaceAnswers } = answersSlice.actions;

export default answersSlice.reducer;
